<template>
  <div>
  <MainNavDrawer v-if="compact" v-model="drawer" />
  <v-app-bar elevation="0" app fixed class="" large>
    <v-container class="px-2 px-sm-3">
      <!-- flex-nowrap: no celular os botões não podem quebrar para uma segunda linha -->
      <v-row class="py-5 flex-nowrap" align="center" no-gutters>
        <!-- No celular: menu hambúrguer com as páginas, ajuda, configurações e sair -->
        <v-btn v-if="compact" icon aria-label="Open menu" @click="drawer = true">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-btn to="/dashboard" v-if="this.$route.name != 'Dashboard'" icon aria-label="Back to dashboard">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <div id="google_translate_element"></div>

        <span class="d-none d-sm-inline text-truncate">{{ this.$route.name }}</span>
        <v-spacer />

        <HelpButton v-if="!compact" />
        <Notifications />
        <MenuButton v-if="!compact" />
        <CreateNewSimulation />
        <CreateNewSimulation :is3d="true"/>
      </v-row>
    </v-container>
  </v-app-bar>
  </div>
</template>
<script>
/**
 * Barra de navegação principal da Aplicação.
 * @displayName Navbar
 * @see https://vuetifyjs.com/en/api/v-app/
 */
import CreateNewSimulation from "@/components/CreateNewSimulation";
import HelpButton from "@/components/HelpButton";
export default {
  name: "AppBar",
  components: {
    MenuButton: () => import("@/components/MenuButton"),
    Notifications: () => import("@/components/Notifications"),
    MainNavDrawer: () => import("@/components/MainNavDrawer"),
    CreateNewSimulation,
    HelpButton
  },
  computed: {
    compact() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  data: () => ({
    drawer: false,
    userName: "",
    avatar: "",
    dialogLogout: false,
    /**
     * @model
     */
    dialogSettings: false
  })
};
</script>
